import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { MxNavigationBarActions } from "../store/ducks/components/NavigationBar/navigationBar";

/**
 * @typedef {Object} Options
 * @property {any[]} [deps]
 *
 * @typedef {() => boolean | void} Callback Retorne `false` para impedir a saída da tela
 */

/**
 * Hook usado para barrar a saída da tela pelo botão "home" da barra de navegação.
 *
 * O callback é consultado antes do alerta de minimizar: retornando `false`, o
 * alerta não abre e o usuário permanece na tela. Cabe ao callback avisar o
 * usuário do motivo.
 *
 * O callback é sempre limpo quando o componente é desmontado.
 * @param {Callback} cb
 * @param {Options} [options={}]
 */
export function useUpdateOnTentarSair(cb, options = {}) {
    const { deps } = Object.assign({}, { deps: [cb] }, options);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(MxNavigationBarActions.onTentarSair(cb));
        return () => {
            dispatch(MxNavigationBarActions.resetOnTentarSair());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
